/* OVANE Warenkorb v40: Steuerung der Leiste. Markup: snippets/ovane-warenkorb.liquid,
   Inhalt: snippets/ovane-warenkorb-inhalt.liquid (neu geholt ueber sections/ovane-warenkorb.liquid).
   Oeffentliche Schnittstelle: window.OVWarenkorb. */
(function(){
  var dlg = document.getElementById('ovwk');
  if(!dlg || window.OVWarenkorb) return;
  var panel = dlg.querySelector('[data-ovwk-panel]');
  var html = document.documentElement;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  var SEKTION = 'ovane-warenkorb';
  var CART = ((window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || (ROOT + 'cart')).replace(/\/$/, '');
  var reduziert = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var hinweis = '', fehlerText = '', laedt = false;
  var letztesOeffnen = 0, schliessTimer = null, vorherFokus = null;

  function q(sel){ return panel.querySelector(sel); }

  function zeigeHinweis(){
    var el = q('[data-ovwk-hinweis]'); if(!el) return;
    var t = q('[data-ovwk-hinweis-text]');
    if(hinweis){ if(t) t.textContent = hinweis; el.hidden = false; }
    else { el.hidden = true; }
  }
  function zeigeFehler(){
    var el = q('[data-ovwk-fehler]'); if(!el) return;
    if(fehlerText){ el.textContent = fehlerText; el.hidden = false; }
    else { el.textContent = ''; el.hidden = true; }
  }
  function zaehler(n){
    var icons = document.querySelectorAll('cart-icon');
    for(var i = 0; i < icons.length; i++){
      var c = icons[i];
      if(typeof c.renderCartBubble === 'function'){
        try { var p = c.renderCartBubble(n, false); if(p && p.catch) p.catch(function(){}); } catch(e){}
      }
    }
  }

  function ersetze(text){
    if(!text) return false;
    var doc = new DOMParser().parseFromString(text, 'text/html');
    var neu = doc.querySelector('[data-ovwk-root]');
    if(!neu) return false;
    var alt = q('[data-ovwk-root]');
    var sc = q('[data-ovwk-scroll]');
    var oben = sc ? sc.scrollTop : 0;
    var akt = document.activeElement;
    var warDrin = !!(akt && panel.contains(akt));
    var fokus = warDrin ? akt.getAttribute('data-ovwk-fokus') : null;
    neu = document.importNode(neu, true);
    if(alt) panel.replaceChild(neu, alt); else panel.appendChild(neu);
    var sc2 = q('[data-ovwk-scroll]'); if(sc2) sc2.scrollTop = oben;
    zeigeHinweis();
    zeigeFehler();
    var n = parseInt(neu.getAttribute('data-ovwk-anzahl'), 10);
    if(!isNaN(n)) zaehler(n);
    if(dlg.open && (warDrin || !akt || akt === document.body)){
      /* Fokus zurueck auf den gleichen Knopf, sonst auf die Leiste selbst
         (nicht auf das X, sonst zeigt Safari dort einen Rahmen). */
      var f = fokus ? q('[data-ovwk-fokus="' + fokus + '"]') : null;
      if(!f || f.disabled) f = panel;
      try { f.focus({ preventScroll: true }); } catch(e){ f.focus(); }
    }
    return true;
  }

  function antwort(r){
    return r.json().catch(function(){ return {}; }).then(function(d){
      if(!r.ok){ throw new Error(d.description || d.message || ''); }
      return d;
    });
  }

  function lade(){
    /* Wichtig: ueber die Startseite und ohne Accept-Header. /cart mit
       Accept: application/json liefert sonst den Warenkorb als JSON statt
       der Sektion. */
    return fetch(ROOT + '?sections=' + SEKTION, {
      credentials: 'same-origin', cache: 'no-store'
    }).then(antwort).then(function(d){ if(d && d[SEKTION]) ersetze(d[SEKTION]); });
  }

  function setzeLaedt(an){ laedt = an; dlg.classList.toggle('is-laedt', an); }

  function sende(pfad, daten, text){
    if(laedt) return Promise.resolve(false);
    setzeLaedt(true);
    fehlerText = '';
    hinweis = '';
    daten.sections = SEKTION;
    daten.sections_url = window.location.pathname;
    return fetch(ROOT + pfad, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(daten)
    }).then(antwort).then(function(d){
      hinweis = text || '';
      if(!(d && d.sections && ersetze(d.sections[SEKTION]))) return lade();
    }).catch(function(err){
      fehlerText = (err && err.message) ? err.message : 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
      return lade().catch(function(){ zeigeFehler(); });
    }).then(function(){ setzeLaedt(false); return true; });
  }

  function aendern(key, menge, text){
    return sende('cart/change.js', { id: key, quantity: menge }, text);
  }

  function oeffnen(){
    clearTimeout(schliessTimer);
    letztesOeffnen = Date.now();
    if(dlg.open){ dlg.classList.add('is-sichtbar'); return; }
    vorherFokus = document.activeElement;
    zeigeHinweis();
    html.setAttribute('scroll-lock', '');
    html.classList.add('ovwk-offen');
    try { dlg.showModal(); } catch(e){ dlg.setAttribute('open', ''); }
    /* Fokus auf die Leiste selbst (tabindex -1, autofocus im Markup).
       Ein Fokus auf dem X wuerde auf dem iPhone einen schwarzen Rahmen zeigen. */
    try { panel.focus({ preventScroll: true }); } catch(e){}
    /* Zwei Frames warten, damit die Leiste hereingleitet. Der Timer ist die
       Sicherung, falls der Browser Frames gerade nicht liefert. */
    var zeigen = function(){ if(dlg.open) dlg.classList.add('is-sichtbar'); };
    requestAnimationFrame(function(){ requestAnimationFrame(zeigen); });
    setTimeout(zeigen, 60);
  }

  function schliessen(){
    if(!dlg.open) return;
    dlg.classList.remove('is-sichtbar');
    clearTimeout(schliessTimer);
    schliessTimer = setTimeout(function(){
      try { dlg.close(); } catch(e){ dlg.removeAttribute('open'); }
      html.removeAttribute('scroll-lock');
      html.classList.remove('ovwk-offen');
      hinweis = ''; fehlerText = '';
      zeigeHinweis(); zeigeFehler();
      if(vorherFokus && vorherFokus.focus && document.contains(vorherFokus)){
        try { vorherFokus.focus({ preventScroll: true }); } catch(e){}
      }
    }, reduziert ? 0 : 280);
  }

  /* Nach einem Hinzufuegen: frischen Inhalt holen, dann oeffnen.
     Spaetestens nach 700 ms geht die Leiste auch ohne frischen Inhalt auf. */
  function nachHinzufuegen(text, sections){
    hinweis = text || 'Hinzugefügt';
    fehlerText = '';
    letztesOeffnen = Date.now();
    var offen = false;
    function auf(){ if(!offen){ offen = true; oeffnen(); } }
    if(sections && sections[SEKTION] && ersetze(sections[SEKTION])){ auf(); return Promise.resolve(); }
    var t = setTimeout(auf, 700);
    return lade().catch(function(){}).then(function(){ clearTimeout(t); zeigeHinweis(); auf(); });
  }

  dlg.addEventListener('click', function(e){
    if(e.target === dlg){ schliessen(); return; }
    var t = e.target.closest ? e.target.closest('[data-ovwk-zu],[data-ovwk-menge],a[href]') : null;
    if(!t || !dlg.contains(t)) return;
    if(t.hasAttribute('data-ovwk-zu')){ e.preventDefault(); schliessen(); return; }
    if(t.hasAttribute('data-ovwk-menge')){
      e.preventDefault();
      if(t.disabled || laedt) return;
      aendern(t.getAttribute('data-ovwk-key'), parseInt(t.getAttribute('data-ovwk-menge'), 10) || 0, t.getAttribute('data-ovwk-text') || '');
      return;
    }
    if(t.tagName === 'A'){
      var u; try { u = new URL(t.href, window.location.href); } catch(_){ return; }
      if(u.origin === window.location.origin && u.pathname === window.location.pathname){ e.preventDefault(); schliessen(); }
    }
  });
  dlg.addEventListener('cancel', function(e){ e.preventDefault(); schliessen(); });
  /* Falls der Browser den Dialog selbst schliesst (zweimal Esc), trotzdem aufraeumen. */
  dlg.addEventListener('close', function(){
    clearTimeout(schliessTimer);
    dlg.classList.remove('is-sichtbar');
    html.removeAttribute('scroll-lock');
    html.classList.remove('ovwk-offen');
    hinweis = ''; fehlerText = '';
  });
  dlg.addEventListener('submit', function(e){
    var b = e.target && e.target.querySelector ? e.target.querySelector('[data-ovwk-kasse]') : null;
    if(b) b.setAttribute('aria-busy', 'true');
  });

  /* Warenkorb-Symbol und alle Links auf /cart oeffnen die Leiste. */
  document.addEventListener('click', function(e){
    if(e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if(!a || dlg.contains(a)) return;
    var u; try { u = new URL(a.href, window.location.href); } catch(_){ return; }
    if(u.origin !== window.location.origin || u.search || u.hash) return;
    if(u.pathname.replace(/\/$/, '') !== CART) return;
    e.preventDefault();
    oeffnen();
    lade().catch(function(){});
  }, true);

  /* Sternify-Kaufknopf: nach erfolgreichem Hinzufuegen oeffnen wir die Leiste. */
  window.SternifyCartOpen = function(){ nachHinzufuegen('Hinzugefügt'); };
  function beobachte(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-st-atc]'), function(b){
      if(b.__ovwk) return;
      b.__ovwk = true;
      var war = b.classList.contains('st_pi-atc--success');
      new MutationObserver(function(){
        var ist = b.classList.contains('st_pi-atc--success');
        if(ist && !war && Date.now() - letztesOeffnen > 1500) nachHinzufuegen('Hinzugefügt');
        war = ist;
      }).observe(b, { attributes: true, attributeFilter: ['class'] });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', beobachte);
  else beobachte();
  window.setTimeout(beobachte, 1500);

  window.addEventListener('load', function(){
    var a = window.Shopify && window.Shopify.actions;
    if(a && a.openCart && typeof a.openCart.configure === 'function'){
      try { a.openCart.configure({ handler: function(){ oeffnen(); return lade().catch(function(){}); } }); } catch(e){}
    }
  });

  /* Zurueck-Taste: Seite kommt aus dem Zwischenspeicher, Warenkorb kann sich
     inzwischen geaendert haben (Kasse, anderer Tab). */
  window.addEventListener('pageshow', function(e){
    if(!e.persisted) return;
    var k = q('[data-ovwk-kasse]'); if(k) k.removeAttribute('aria-busy');
    setzeLaedt(false);
    lade().catch(function(){});
  });

  window.OVWarenkorb = { oeffnen: oeffnen, schliessen: schliessen, laden: lade, nachHinzufuegen: nachHinzufuegen, aendern: aendern };
})();
